export const ContactAddingList = [
    {
        label: "Էլ․ հասցե",
        inputType: "input",
        type: "text",
        placeholder: "Էլ․ հասցե",
        name: "email",
        maxLength: 500
    },
    {
        label: "Հեռախոս",
        inputType: "input",
        type: "text",
        // regExp:/^[+\d]\d*$/,
        placeholder: "Հեռախոս",
        name: "phoneNumber",
        maxLength: 20
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Facebook",
        name: "facebook",
        maxLength: 1000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Instagram",
        name: "instagram",
        maxLength: 1000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Youtube",
        name: "youtube",
        maxLength: 1000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Telegram",
        name: "telegram",
        maxLength: 1000
    }
];
